import { ViewMode } from 'app/area/saved-reports/types-store';
import { CodetableWireFormat } from 'app/infrastructure/ui/form/types-codetable';
import { FavouriteDefinition } from 'app/types-shared';

export const ACTION = {
  REQUEST_EXECUTE_REPORT: 'SAVED_REPORTS:REQUEST_EXECUTE_REPORT',
  RECEIVE_EXECUTE_REPORT: 'SAVED_REPORTS:RECEIVE_EXECUTE_REPORT',
  REQUEST_NEW_FOLDER: 'SAVED_REPORTS:REQUEST_NEW_FOLDER',
  REQUEST_FAILED: 'SAVED_REPORT:REQUEST_FAILED',
  CLEAR_NEW_FOLDER: 'SAVED_REPORTS:CLEAR_NEW_FOLDER',
  CLEAR_ALL: 'SAVED_REPORTS:CLEAR_FORM',
  CLEAR_FOLDER_DATA: 'SAVED_REPORTS:CLEAR_FOLDER_DATA',
  REQUEST_REPORTS: 'SAVED_REPORTS:REQUEST_REPORTS',
  RECEIVE_REPORT: 'SAVED_REPORTS:RECEIVE_REPORTS',
  DELETE_REPORT: 'SAVED_REPORTS:DELETED_REPORT',
  RECEIVE_FOLDER_FAVOURITE: 'SAVED_REPORTS:RECEIVE_FOLDER_FAVOURITE',
  REQUEST_FOLDER_FAVOURITE: 'SAVED_REPORTS:REQUEST_FOLDER_FAVOURITE',
  REQUEST_SEARCH_REQUIRED_USERS: 'SAVED_REPORTS:REQUEST_SEARCH_REQUIRED_USERS',
  RECEIVE_SEARCH_REQUIRED_USERS: 'SAVED_REPORTS:RECEIVE_SEARCH_REQUIRED_USERS',
  REQUEST_BOOKMARKED_REPORTS: 'SAVED_REPORTS:REQUEST_BOOKMARKED_REPORTS',
  RECEIVE_BOOKMARKED_REPORTS: 'SAVED_REPORTS:RECEIVE_BOOKMARKED_REPORTS',
  CHANGE_VIEW_MODE: 'SAVED_REPORTS:CHANGE_VIEW_MODE',
  CHANGE_VIEW_MODE_COMPANY_REPORT: 'SAVED_REPORTS:CHANGE_VIEW_MODE_COMPANY_REPORT',
  CHANGE_VIEW_MODE_DASHBOARD: 'SAVED_REPORTS:CHANGE_VIEW_MODE_DASHBOARD'
};

export class RequestExecuteReport {
  public type: string = ACTION.REQUEST_EXECUTE_REPORT;
}
export class RequestFailed {
  public type: string = ACTION.REQUEST_FAILED;
}

export class RequestNewFolder {
  public type: string = ACTION.REQUEST_NEW_FOLDER;
}

export class ClearNewFolder {
  public type: string = ACTION.CLEAR_NEW_FOLDER;
}

export class ClearAll {
  public type: string = ACTION.CLEAR_ALL;
}

export class RequestReports {
  public type: string = ACTION.REQUEST_REPORTS;
}
export class RequestFolderFavourite {
  public type: string = ACTION.REQUEST_FOLDER_FAVOURITE;
}

export class ReceiveFolderFavourite {
  public type: string = ACTION.RECEIVE_FOLDER_FAVOURITE;
  constructor(public definition:FavouriteDefinition) {}
}

export class ClearFolderData {
  public type: string = ACTION.CLEAR_FOLDER_DATA;
}

export class ReceiveReports {
  public type: string = ACTION.RECEIVE_REPORT;
  public reports: CodetableWireFormat[];

  constructor(reports: CodetableWireFormat[]) {
    this.reports = reports;
  }
}

export class RequestSearchRequiredUsers {
  public type: string = ACTION.REQUEST_SEARCH_REQUIRED_USERS;
}

export class ReceiveSearchRequiredUsers {
  public type: string = ACTION.RECEIVE_SEARCH_REQUIRED_USERS;
  public searchRequiredUsers: boolean;

  constructor(searchRequiredUsers: boolean) {
    this.searchRequiredUsers = searchRequiredUsers;
  }
}
export class RequestBookmarkedReports {
  public type: string = ACTION.REQUEST_BOOKMARKED_REPORTS;
}
export class ReceiveBookmarkedReports {
  public type: string = ACTION.RECEIVE_BOOKMARKED_REPORTS;
  public bookmarkedReports: CodetableWireFormat[];

  constructor(bookmarkedReports: CodetableWireFormat[]) {
    this.bookmarkedReports = bookmarkedReports;
  }
}

export class ChangeViewMode {
  public type: string = ACTION.CHANGE_VIEW_MODE;
  public mode: ViewMode;

  constructor(mode: ViewMode) {
    this.mode = mode;
  }
}

export class ChangeViewModeCompanyReport {
  public type: string = ACTION.CHANGE_VIEW_MODE_COMPANY_REPORT;
  public mode: ViewMode;

  constructor(mode: ViewMode) {
    this.mode = mode;
  }
}

export class ChangeViewModeDashboard {
  public type: string = ACTION.CHANGE_VIEW_MODE_DASHBOARD;
  public mode: ViewMode;

  constructor(mode: ViewMode) {
    this.mode = mode;
  }
}
